import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'controlador-trade');

const controladorTradeActions = {
  listar: { method: 'GET', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, controladorTradeActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/controlador-trade/controlador-trade.js